export let showMessageOptionsText = "VBF4we";
export let switchToPlainTextText = "zQb$Td";
export let switchToHTMLTextText = "Cu5Nne";
export let print_Draft_Button = "eTNHec";
export let save_Button = "AxsHnc";
export let saveAs_Button = "MQRCxc";
export let downloadAs_Button = "Zwvg9c";
export let attachSig_FlyoutButton = "EtaFuc";
export let encrypt_FlyoutButtonText = "UPOZ1";
export let sensitivity_FlyoutButton_ActionControl = "BNalVb";
export let toggleFromText = "Jm4j2";
export let toggleBccText = "VIb5se";
export let toggleCcText = "$cLoIc";
export let readReceiptText = "tkHeQb";
export let deliveryReceiptText = "N$GNke";
export let attachFile_FlyoutButton_ActionControl = "rtyu$b";
export let proofingOptionsText = "ZNI6nc";
export let getAddIns_Button_ActionControl = "Ov4n4d";
export let polls_Button_ActionControl = "DmY9Q";
export let fluidText = "hi82je";
export let recordLoopVideo = "O9dvxe";
export let disallowReactionsText = "KeNRMe";
export let highImportance = "kIyZAc";
export let lowImportance = "SA1E2d";
export let draftWithCopilotText = "ciToVc";
export let coachWithCopilotText = "XST5N";
export let toggleShowReplyToText = "Fdqh6b";
export let mailTemplateText = "GDmPs";
export let showFieldsText = "hA6DBb";
export let trackingDropdownText = "JRghNe";
export let quickPartsText = "qOwvOb";
export let checkNameTitle = "b25qPe";
export default {showMessageOptionsText,switchToPlainTextText,switchToHTMLTextText,print_Draft_Button,save_Button,saveAs_Button,downloadAs_Button,attachSig_FlyoutButton,encrypt_FlyoutButtonText,sensitivity_FlyoutButton_ActionControl,toggleFromText,toggleBccText,toggleCcText,readReceiptText,deliveryReceiptText,attachFile_FlyoutButton_ActionControl,proofingOptionsText,getAddIns_Button_ActionControl,polls_Button_ActionControl,fluidText,recordLoopVideo,disallowReactionsText,highImportance,lowImportance,draftWithCopilotText,coachWithCopilotText,toggleShowReplyToText,mailTemplateText,showFieldsText,trackingDropdownText,quickPartsText,checkNameTitle};